module.exports = __webpack_public_path__ + "img/9_gift.a8c9bbd8.png";